// extracted by mini-css-extract-plugin
module.exports = {"v1vw5mx3":"v1vw5mx3"};